module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "c-project-facts"
  }, _vm._l((_vm.facts), function(fact) {
    return _c('li', {
      staticClass: "c-project-facts__item"
    }, [_c('div', {
      staticClass: "c-project-facts__title",
      domProps: {
        "innerHTML": _vm._s(fact.title)
      }
    }), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(fact.text)
      }
    })])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43f95ba6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectFacts.vue
// module id = 265
// module chunks = 0